<template>
  <div>
    <template v-if="mode === 'DESIGN'">
      <el-input size="small" class="disabled-box" :placeholder="placeholder"  maxlength="50" show-word-limit/>
    </template>
    <template v-else>
      <el-input v-if="!readerMode || perm==='E'" size="small" clearable v-model="_value" :placeholder="placeholder" :disabled="perm==='R'" maxlength="50"  show-word-limit/>
      <div v-else class="form-item-text">{{_value}}</div>
      <!-- <el-input v-else size="small" clearable v-model="_value" :placeholder="placeholder"  maxlength="50" show-word-limit disabled/> -->
    </template>
    <div v-if="isReplacement" class="total-time-con" :class="{'show-label': perm==='R'}">
      <span class="text">本月已补卡次数：</span>
      <span class="time">{{cardCount}}</span>
    </div>
  </div>
</template>

<script>
import componentMinxins from '../ComponentMinxins'
import approvalUserInfo from '../ApprovalUserInfo'
export default {
  mixins: [componentMinxins,approvalUserInfo],
  name: "TextInput",
  components: {},
  props: {
    value: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: '请输入'
    },
    readerMode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {}
  },
  methods: {}
}
</script>

<style scoped lang="scss">
 .total-time-con{
  padding-top: 6px;
  line-height: 1;
  // color: #2F3030;
    .text{
      color: #939696;
    }
    .time{
      color: #2F3030;
    }
  }
  .show-label{
    // position: absolute;
    margin:21px 0 15px -88px;
    .text{
      padding-right: 8px;
    }
  }
</style>
